var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1129_12441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.88881 5.97169C1.4148 5.14514 1.18592 4.47023 1.04792 3.78609C0.84381 2.77428 1.3109 1.78589 2.08469 1.15522C2.41172 0.888679 2.78661 0.979749 2.98 1.32669L3.41659 2.10994C3.76264 2.73077 3.93567 3.04118 3.90135 3.37028C3.86703 3.69938 3.63368 3.96742 3.16698 4.50349L1.88881 5.97169ZM1.88881 5.97169C2.84825 7.64464 4.35392 9.15114 6.0288 10.1117M6.0288 10.1117C6.85535 10.5857 7.53025 10.8146 8.2144 10.9526C9.2262 11.1567 10.2146 10.6896 10.8452 9.91579C11.1118 9.58879 11.0207 9.21389 10.6738 9.02049L9.89055 8.58389C9.2697 8.23784 8.9593 8.06484 8.6302 8.09914C8.3011 8.13344 8.03305 8.36679 7.497 8.83349L6.0288 10.1117Z",
    stroke: "#2C8C53",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1129_12441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.acc6d6ace755835210e751f7a78b0309.svg";
export { ForwardRef as ReactComponent };